/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Injectable} from '@angular/core';
import {DelAddressTemplateDTO, DelAddressTemplateListVO} from '@well/domain';
import { HttpClient } from '@angular/common/http';
import {EnvironmentService} from "@irian-ro/util-environment";
import {Observable} from 'rxjs';
import { AbstractResourceService, JsonApiListResourceMetadataBase, JsonApiResource, QueryParams } from '@irian-ro/abstract-resource';
import { AddressDTO, DelAddressDtoModel } from "@well/address-management-shell-api";
import {
  AddressSaveTemplateServiceInterface,
  LocalAddressSearchServiceInterface
} from "@well/address-management/data-access";

@Injectable({
  providedIn: 'root'
})
export class DelAddressTemplateResourceService extends AbstractResourceService<DelAddressTemplateListVO, DelAddressTemplateListVO, any, any> implements LocalAddressSearchServiceInterface,AddressSaveTemplateServiceInterface {

  constructor(httpClient: HttpClient, environmentService: EnvironmentService) {
    super(
      httpClient,
      environmentService.getEnvironmentProperty('delAddressTemplateUrl'),
      DelAddressTemplateListVO,
      DelAddressTemplateListVO
    );
  }

  getSearchResults(query?: any,
          additionalParams?: any,
          customerUuid?: string): Observable<JsonApiResource<AddressDTO[], JsonApiListResourceMetadataBase>> {

    const queryString = new QueryParams(
      query,
      additionalParams ? additionalParams : []).toString();

    const url = customerUuid ? `${this.url}/search/${customerUuid}${queryString}` : `${this.url}/search${queryString}`;

    return this.httpClient?.get(url)
      .pipe(this.mapToListOfObjects());
  }

  saveTemplateAddress(address: AddressDTO, partnerLegalEntityUuid?: string): Observable<JsonApiResource<DelAddressDtoModel, any>> {
    if(partnerLegalEntityUuid){
      return <Observable<JsonApiResource<DelAddressDtoModel, any>>>this.httpClient?.post(`${this.url}/${partnerLegalEntityUuid}`, address);
    }else{
      return <Observable<JsonApiResource<DelAddressDtoModel, any>>>this.httpClient?.post(`${this.url}`, address);
    }
  }

  delete(uuid: string): Observable<DelAddressTemplateDTO> {
    return <Observable<DelAddressTemplateDTO>>this.httpClient?.delete(`${this.url}/${uuid}`, {
      headers: this.headers
    });
  }

  update(addressTemplateDTO: DelAddressTemplateDTO): Observable<DelAddressTemplateDTO> {
    return <Observable<DelAddressTemplateDTO>>this.httpClient?.put(`${this.url}`, addressTemplateDTO, {
      headers: this.headers
    });
  }

  getAddressTemplateDetails(uuid: string): Observable<JsonApiResource<DelAddressTemplateDTO, any>> {
    return <Observable<JsonApiResource<DelAddressTemplateDTO, any>>>this.httpClient?.get(`${this.url}/${uuid}`, {
      headers: this.headers
    });
  }
}
